import "core-js/modules/es.array.slice";
import _objectSpread from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, tool, commonData } from "@/mixins/index";
export default {
  name: "userActionLog",
  mixins: [loadMoreList, tool, commonData],
  data: function data() {
    return {
      pagingReqFn: "userOperationLog",
      userList: [],
      typeList: [],
      content: '',
      drawer: false,
      dateType: 'arr'
    };
  },
  created: function created() {
    this.getAll();
    this.getTypeList();
    this.getNowDate(this.dateType);
    this.paramsData.starttime = this.timestampToYYYYMMDD(this.paramsData.start_time);
    this.paramsData.endtime = this.timestampToYYYYMMDD(this.paramsData.end_time);
    this.getList();
  },
  activated: function activated() {},
  methods: {
    openParms: function openParms(row) {
      this.content = row.params;
      this.drawer = true;
    },
    timestampToYYYYMMDD: function timestampToYYYYMMDD(timestamp) {
      var date = new Date(timestamp * 1000); // 将时间戳转换为Date对象

      var year = date.getFullYear();
      var month = ("0" + (date.getMonth() + 1)).slice(-2); // 月份需要加1，且保证两位数显示

      var day = ("0" + date.getDate()).slice(-2); // 保证日期显示两位数

      return year + '-' + month + '-' + day;
    },
    seachDateChange: function seachDateChange(e) {
      this.paramsData.start_time = e ? e[0] / 1000 : '';
      this.paramsData.end_time = e ? e[1] / 1000 : '';
      this.paramsData.starttime = this.timestampToYYYYMMDD(this.paramsData.start_time);
      this.paramsData.endtime = this.timestampToYYYYMMDD(this.paramsData.end_time);
    },
    getAll: function getAll() {
      var _this = this;

      this.$api.userList().then(function (res) {
        _this.userList = res.data.data;
      });
    },
    getTypeList: function getTypeList() {
      var _this2 = this;

      this.$api.userOperationLogData().then(function (res) {
        _this2.typeList = res.data;
      });
    },
    exportData: function exportData() {
      var _this3 = this;

      var columns = [{
        label: '用户ID',
        prop: 'user_id'
      }, {
        label: '用户名称',
        prop: 'nickname'
      }, {
        label: '角色',
        prop: 'title'
      }, {
        label: 'IP地址',
        prop: 'ip'
      }, {
        label: '访问地址名称',
        prop: 'city'
      }, {
        label: '操作名称',
        prop: 'url_name'
      }, {
        label: '操作',
        prop: 'url'
      }, {
        label: '时间',
        prop: 'created_at'
      }];
      this.$api.userOperationLog(_objectSpread(_objectSpread({}, this.paramsData), {}, {
        page_size: this.total + 10
      })).then(function (res) {
        var data = res.data.data || [];

        _this3.$export.excel({
          columns: columns,
          data: data,
          title: _this3.$route.meta.title
        });
      });
    }
  }
};